<template>
    <div class="m-login__forget-password" style="display: block;">
        <div class="m-login__head">
            <h3 class="m-login__title">{{ labels.forgot_password_prompt }}</h3>
            <div class="m-login__desc" v-show="!successResponse">{{ labels.reset_password_instructions }}</div>
            <div class="m-login__desc" v-show="successResponse">{{ successResponse }}</div>
        </div>
        <form class="m-login__form m-form" action="" v-show="!successResponse">
            <div class="m-alert m-alert--outline alert alert-danger alert-dismissible animated fadeIn" role="alert" v-show="errorMessage">
                <span>{{ errorMessage }}</span>
            </div>
            <div class="form-group m-form__group" @input="userInputListener">
                <input class="form-control m-input" type="text" placeholder="Email" name="email" id="m_email" autocomplete="off" v-model="email">
            </div>
            <div class="m-login__form-action">
                <button type="button" id="m_login_forget_password_submit" class="btn btn-focus m-btn m-btn--pill m-btn--custom" :class="disableSubmit" :disabled="disableSubmit" @click="passwordResetAction">{{ labels.submit }}</button>
                <router-link tag="button" to="/" id="m_login_forget_password_cancel" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom">{{ labels.cancel }}</router-link>
            </div>
        </form>
        <div class="m-login__form-action" v-show="successResponse" style="text-align: center; margin: 1.2em 0;">
            <router-link tag="button" to="/" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom">{{ labels.return }}</router-link>
        </div>
    </div>
</template>

<script>
import { HTTP } from '../../assets/js/axiosConfig'
import { mapState } from 'vuex'
// Mixins
import TimeoutMsg from '../../assets/js/mixins'
import UserInputListener from '../../assets/js/mixins'

export default {
    name: 'PasswordReset',
    mixins: [TimeoutMsg, UserInputListener],
    data () {
        return {
            email: '',
            errorMessage: '',
            successResponse: ''
        }
    },
    computed: {
        ...mapState([
            'labels'
        ]),
        disableSubmit () {
            return !this.email.length ? 'disabled' : false
        }
    },
    methods: {
        passwordResetAction () {
            HTTP.put(`/api/users/password/${this.email}`)
                .then(() => {
                    this.successResponse = this.labels['message.password_reset_success']
                })
                .catch(err => {
                    if (err.response && err.response.status === 400) {
                        this.errorMessage = this.labels['error.user_not_found']
                    } else {
                        this.errorMessage = this.labels['error.cannot_reset_password']
                    }
                    this.timeoutMsg()
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Security/ForgotPassword.vue